export default "__VITE_ASSET__DnRDyn5N__"